import styled from 'styled-components'

export const HEADER_HEIGHT = 52
export const LEFT_PANEL_WIDTH = 208
export const CARDS_CONTAINER_WIDTH = 372
export const REWRITE_PANEL_WIDTH = 420

export const ProofReaderContentContainer = styled.div`
  display: flex;
  flex-direction: row;
`

export const ProofReaderLayoutContainer = styled.div`
  display: flex;
  flex-flow: column;
`

export const WorkspaceContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`
